// Chakra imports
import {
  Portal,
  Box,
  useDisclosure,
  useColorModeValue,
} from '@chakra-ui/react';

// Layout components
import Navbar from 'components/navbar/NavbarAdmin.js';
import Sidebar from 'components/sidebar/Sidebar.js';
import { SidebarContext } from 'contexts/SidebarContext';
import socket from 'constants/helper/socket';
import { getUser } from 'constants/helper/authStorage';

import React, { useState } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import routes from 'routes.js';
import { useTranslation } from 'react-i18next';

// Pages
export default function Dashboard(props) {
  const { t } = useTranslation();
  const { ...rest } = props;

  const [fixed] = useState(false);
  const [toggleSidebar, setToggleSidebar] = useState(false);
  // sidebar collapse state
  const [isCollapsed, setCollapsed] = useState(false);
  const toggleCollapse = () => setCollapsed(!isCollapsed);
  const { onOpen } = useDisclosure();
  const user = getUser();

  React.useEffect(() => {
    if (!socket.connected) {
      socket.connect();
    }

    const onConnect = () => {
      console.log('Socket connected:', socket.id);
      if (user?._id) {
        socket.emit('join', user._id);
      }
    };

    const onDisconnect = (reason) => {
      console.log('Socket disconnected:', reason);
    };

    const onConnectError = (error) => {
      console.error('Socket connection error:', error);
    };

    socket.on('connect', onConnect);
    socket.on('disconnect', onDisconnect);
    socket.on('connect_error', onConnectError);
    
    // Check if already connected (for hot reload or re-mount)
    if (socket.connected) {
        onConnect();
    }

    return () => {
      socket.off('connect', onConnect);
      socket.off('disconnect', onDisconnect);
      socket.off('connect_error', onConnectError);
      socket.disconnect();
    };
  }, []);

  const getRoute = () => {
    return window.location.pathname !== '/admin/full-screen-maps';
  };

  // 🔹 Active brand text
  const getActiveRoute = (routes) => {
    let activeRoute = 'Default Brand Text';
    for (let i = 0; i < routes.length; i++) {
      if (routes[i].collapse) {
        const child = getActiveRoute(routes[i].items);
        if (child !== activeRoute) return child;
      } else if (
        routes[i].layout &&
        window.location.href.includes(routes[i].layout + routes[i].path)
      ) {
        return routes[i].messageNavbar || routes[i].name.toLowerCase();
      }
    }
    return activeRoute;
  };

  const getActiveNavbar = (routes) => {
    for (let i = 0; i < routes.length; i++) {
      if (routes[i].collapse) {
        const child = getActiveNavbar(routes[i].items);
        if (child !== false) return child;
      } else if (
        routes[i].layout &&
        window.location.href.includes(routes[i].layout + routes[i].path)
      ) {
        return routes[i].secondary;
      }
    }
    return false;
  };

  // 🔹 Create routes from config
  const getRoutes = (routes) => {
    return routes.map((route, key) => {
      if (route.collapse) {
        return getRoutes(route.items);
      }

      if (route.layout === '/admin') {
        return <Route path={route.path} element={route.component} key={key} />;
      }

      return null;
    });
  };

  document.documentElement.dir = 'ltr';

  return (
    <Box>
      <SidebarContext.Provider
        value={{
          toggleSidebar,
          setToggleSidebar,
          isCollapsed,
          toggleCollapse,
        }}
      >
        <Sidebar routes={routes} {...rest} />

        <Box
          float="right"
          minHeight="100vh"
          height="100%"
          overflow="auto"
          position="relative"
          maxHeight="100%"
          w={{
            base: '100%',
            md: isCollapsed ? 'calc(100% - 80px)' : 'calc(100% - 290px)',
          }}
          maxWidth={{
            base: '100%',
            md: isCollapsed ? 'calc(100% - 80px)' : 'calc(100% - 290px)',
          }}
          transition="all 0.3s cubic-bezier(0.4, 0, 0.2, 1)"
          transitionProperty="width, max-width"
          background={useColorModeValue(
            'white',
            'linear-gradient(to right, #2c3e50,rgb(55, 117, 127))',
          )}
        >
          <Portal>
            <Navbar
              onOpen={onOpen}
              logoText="Electro Pathy"
              brandText={t(getActiveRoute(routes))}
              secondary={getActiveNavbar(routes)}
              fixed={fixed}
              {...rest}
            />
          </Portal>

          {getRoute() && (
            <Box p="20px" minH="100vh">
              <Routes>
                {getRoutes(routes)}
                <Route
                  index
                  element={<Navigate to="/admin/protocol" replace />}
                />
                {/* <Route
                  path="/admin/addDiseaseProtocol"
                  element={<AddDiseaseProtocol />}
                /> */}
              </Routes>
            </Box>
          )}
        </Box>
      </SidebarContext.Provider>
    </Box>
  );
}
